<!-- src/app/modules/authentication/presentation/pages/register/register.component.html -->
<div class="container">
  <div class="login">
    <img class="logo" src="/assets/logo/login-logo.svg" alt="Logo" />

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <!-- Email -->
      <label class="form-label">Email</label>
      <gbui-form-group class="first">
        <gbui-input
          class="inputs"
          simple
          (keyup)="emailToLowercase($event)"
          placeholder="Enter your email"
          formControlName="email"
        ></gbui-input>
      </gbui-form-group>

      <!-- Global error (login failure) -->
      <gbui-animated-height-display [display]="(displaError$ | async)">
        <p gbui-feedback-text="danger">{{ errorMessage$ | async }}</p>
      </gbui-animated-height-display>

      <!-- Email-check error (optional) -->
    <!-- Email-check specific error -->
<!-- Email-check error – shows exact message from backend -->
<gbui-animated-height-display [display]="(checkError$ | async) !== null">
  <p gbui-feedback-text="danger">
    {{ (checkError$ | async)?.message }}
  </p>
</gbui-animated-height-display>

      <!-- Submit -->
      <button
        class="buttons"
        gbui-button
        type="submit"
        context="primary"
        [busy]="(loading$ | async) ?? false"
        [disabled]="registerForm.invalid || (checking$ | async) ?? false"
      >
        Sign-Up
      </button>
    </form>
  </div>
</div>